<template>
  <form @submit.prevent="typeAction" class="row">
    <div class="mb-3">
      <label>Name</label>
      <input
          v-model="customer.name"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.customer.name.$error,
          }"
      />
      <p
          v-for="error of v$.customer.name.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3 col-6">
      <label>Short Code</label>
      <input
          v-model="customer.shortCode"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.customer.shortCode.$error,
          }"
      />
      <p
          v-for="error of v$.customer.shortCode.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3 col-6">
      <label>Tier</label>
      <multiselect v-model="customer.tier" :options="tiers.objects" :class="{
                        'is-invalid': v$.customer.tier.$error,
                  }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name"></multiselect>
      <p
          v-for="error of v$.customer.tier.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Description</label>
      <textarea
          v-model="customer.description"
          class="form-control"
          :class="{
            'is-invalid': v$.customer.description.$error,
          }"
          rows="5"
      ></textarea>
      <p
          v-for="error of v$.customer.description.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in userSettingsErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-3 h3" disabled v-if="userSettingsLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import Multiselect from "vue-multiselect";
import {mapGetters} from "vuex";
import {ALL_CUSTOMER_TIERS} from "@/gql";

export default {
name: "customer-type-form",
  components: {Multiselect},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      customer: this.selected_type,
      tiers: {
        objects: []
      },
      category_options: [
        { value: '1', label: 'Category 1' },
        { value: '2', label: 'Category 2' }
      ],
    }
  },
  computed: {
    ... mapGetters({
      userSettingsLoading: 'user/userSettingsLoading',
      userSettingsErrors: 'user/userSettingsErrors'
    }),
  },
  apollo: {
    tiers: {
      query: ALL_CUSTOMER_TIERS,
      variables (){
        return {
          page: 0,
          perPage: 30
        }
      }
    },
  },
  props: {
    selected_type: {
      type: Object,
      default () {
        return {
          name: '',
          shortCode: '',
          tier: '',
          description: ''
        }
      }
    },
    button_text: {type: String}
  },
  validations () {
    return {
      customer: {
        name: {required},
        shortCode: {required},
        tier: {required},
        description: {required}
      }
    }
  },
  methods: {
    async typeAction(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }
      const data = {
        name: this.customer.name,
        shortCode: this.customer.shortCode,
        tier: this.customer.tier.publicId,
        description: this.customer.description
      }
      this.$emit('typeAction', data)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
